import { render, staticRenderFns } from "./ContMyTablesComponent.vue?vue&type=template&id=78e4298a&scoped=true&lang=pug"
import script from "./ContMyTablesComponent.vue?vue&type=script&lang=js"
export * from "./ContMyTablesComponent.vue?vue&type=script&lang=js"
import style0 from "./ContMyTablesComponent.vue?vue&type=style&index=0&id=78e4298a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e4298a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78e4298a')) {
      api.createRecord('78e4298a', component.options)
    } else {
      api.reload('78e4298a', component.options)
    }
    module.hot.accept("./ContMyTablesComponent.vue?vue&type=template&id=78e4298a&scoped=true&lang=pug", function () {
      api.rerender('78e4298a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/my_objects/components/ContMyTablesComponent.vue"
export default component.exports